import { render, staticRenderFns } from "./online-courses.vue?vue&type=template&id=6cbb1cfd"
import script from "./online-courses.vue?vue&type=script&lang=js"
export * from "./online-courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports